<template>
  <div class="MIDAS-TOAST-loading">
    <p class="MIDAS-TOAST-loading__txt">
      <i v-if="needLoading" class="MIDAS-TOAST-loading__icon icon-load"></i>
      {{ msg }}
    </p>
    <!-- <p class="MIDAS-TOAST-loading__txt">加载中。。。。</p> -->
  </div>
</template>

<script setup lang="ts">
import {defineEmits} from "vue"
interface Props {
  msg?: string
  needLoading?: boolean
}
withDefaults(defineProps<Props>(), {
  msg: "",
  needLoading: false,
})
const emits = defineEmits<{(e: "close"): void}>()
setTimeout(() => {
  emits("close")
}, 2000)
</script>
<style scoped></style>
